module.exports = __webpack_public_path__ + "static/media/you-notice.0a72ec94.mp3";